import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTimeCheckingStart,
  getTimeCheckingSuccess,
  getTimeCheckingFailed,
} from "../redux/getTimeKeeping";
import { getTimeCheckingAPI } from "core/http/service/decleareLeave";
import { transformDataTimeChecking } from "core/http/service/decleareLeave/const";

function* getTimeCheckingWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getTimeCheckingAPI, {
      screenCode,
      month: payload.month,
      year: payload.year,
    });
    const dataFormatted = transformDataTimeChecking(res);
    yield put({
      type: getTimeCheckingSuccess.type,
      payload: { id: payload.id, data: dataFormatted },
    });
  } catch (error: any) {
    yield put({
      type: getTimeCheckingFailed.type,
      payload: { id: payload.id },
    });
  }
}

function* watchGetTimeChecking() {
  yield takeLatest(getTimeCheckingStart.type, getTimeCheckingWork);
}

export default function* getTimeCheckingSaga() {
  yield all([watchGetTimeChecking()]);
}
